import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "size"]

  clearDims() {
    this.inputTargets.forEach(input => { input.value = "" })
  }

  inputChanged() {
    const hasCustom = this.inputTargets.some(input => input.value.trim() !== "")
    if (!hasCustom) return
    this.sizeTargets.forEach(cb => { cb.checked = false })
  }
}
